// =====================================================
// WeLearn Pro Player - UI module
// =====================================================

import Debug from './util/debugHelper.js';
import Convert from './util/conversionHelper';

export default class UI {
    constructor(player) {
        this.player = player;
        this.debug = new Debug(this.player.options.debug);
    }

    bindWlpPlayer() {
        // Declare a WeLearn Pro Player selector
        let plyrElement = $(document).find('.plyr');

        // Apply wlpPlayer element for CSS
        plyrElement.addClass('wlpPlayer');

        if (this.player.options.previewMode === false) {
            this._renderProgressBar();
            this._seekablePlyrProgressBar(this.player.options.seekable);
        }
    }

    _renderProgressBar() {
        // Declare a WeLearn Pro Player selector
        let plyrElement = $(document).find('.plyr');

        // Create progress bar
        plyrElement.after(
            "<div class=\"wlpVideo__progress-bar\"></div>"
        );

        var videoDuration;

        if (plyrElement.length !== 0) {
            videoDuration = Math.floor(this.player.plyrPlayer.duration); // TODO: Quick fix progress bar render span incorrectly by render extra 1 span
        } else {
            videoDuration = 1;
        }

        for (let i = 1; i <= videoDuration; i++) {
            $('.wlpVideo__progress-bar').append(
                "<span class='tick' data-toggle='tooltip' data-placement='bottom' title='" + Convert.toTimestamp(i) + "' data-timestamp=" + i + "></span>"
            );
        }

        $('[data-toggle="tooltip"]').tooltip({
            template: '<div class="tooltip wlpVideo__progress-bar-tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
        });
    }

    /**
     * Set this video can be seek or not.
     * @param canSeek - true and false
     */
    _seekablePlyrProgressBar(canSeek) {
        if (canSeek === true) {
            $('.plyr__progress').css({ 'pointer-events': 'auto' });
            return true;
        } else {
            //$('.plyr__progress').css('pointer-events', 'none');
            $('.plyr__progress').css('pointer-events', 'auto');
            return false;
        }
    }
}
